const LIVE_QUERY_PARAM = 'live'

const LIVE_TIMING_ORIGIN = 'https://timing.aravaiparunning.com'
const LIVE_TIMING_WS_URL = 'wss://timing.aravaiparunning.com/ws'
const LIVE_RACEDAYREG_BASE_URL = 'https://live.aravaiparunning.com/reg/'
const LOCAL_RACEDAYREG_BASE_URL = 'http://localhost:8081/reg/'

function currentLocation(locationLike = window.location) {
  return locationLike
}

function isDevelopment() {
  return process.env.NODE_ENV === 'development'
}

function buildUrl(baseUrl, path = '', query = {}) {
  const url = new URL(String(path || '').replace(/^\//, ''), baseUrl)

  Object.entries(query).forEach(([key, value]) => {
    if (null == value) {
      return
    }

    if (Array.isArray(value)) {
      value.forEach(v => url.searchParams.append(key, String(v)))
      return
    }

    url.searchParams.set(key, String(value))
  })

  return url.toString()
}

export function shouldUseLiveWebsite(locationLike = window.location) {
  const location = currentLocation(locationLike)
  return new URLSearchParams(location?.search || '').has(LIVE_QUERY_PARAM)
}

export function getTimingOrigin(locationLike = window.location) {
  const location = currentLocation(locationLike)

  if (isDevelopment()) {
    return shouldUseLiveWebsite(location) ?
      LIVE_TIMING_ORIGIN :
      `${location.protocol}//${location.hostname}:3000`
  }

  return `${location.protocol}//${location.host}`
}

export function getTimingApiBaseUrl(locationLike = window.location) {
  return buildUrl(`${getTimingOrigin(locationLike)}/`, 'api/v1/')
}

export function getTimingWebsocketUrl(locationLike = window.location) {
  const location = currentLocation(locationLike)

  if (isDevelopment() && !shouldUseLiveWebsite(location)) {
    return `ws://${location.hostname}:3000/ws`
  }

  return LIVE_TIMING_WS_URL
}

export function getRacedayRegBaseUrl(locationLike = window.location) {
  const location = currentLocation(locationLike)

  if (isDevelopment() && !shouldUseLiveWebsite(location)) {
    return LOCAL_RACEDAYREG_BASE_URL
  }

  return LIVE_RACEDAYREG_BASE_URL
}

export function buildTimingUrl(path = '', query = {}, locationLike = window.location) {
  return buildUrl(`${getTimingOrigin(locationLike)}/`, path, query)
}

export function buildTimingApiUrl(path = '', query = {}, locationLike = window.location) {
  return buildUrl(getTimingApiBaseUrl(locationLike), path, query)
}

export function buildRacedayRegUrl(path = '', query = {}, locationLike = window.location) {
  return buildUrl(getRacedayRegBaseUrl(locationLike), path, query)
}

export function buildPacketPdfUrl(raceEventId, participantId, options = {}, locationLike = window.location) {
  const { skip = 0, ...query } = options

  return buildTimingApiUrl(
    `race_events/${raceEventId}/participants/${participantId}/packet.pdf`,
    { skip, ...query },
    locationLike
  )
}

export function buildRaceRegistrationUrl(raceId, query = {}, locationLike = window.location) {
  return buildTimingUrl(`races/${raceId}/registration`, query, locationLike)
}

export function buildRacePacketsUrl(raceId, query = {}, locationLike = window.location) {
  return buildTimingUrl(`races/${raceId}/packets.pdf`, query, locationLike)
}
